import { useCallback, useContext } from 'react';
import { UploadStateContext } from '../context';
import { fileToObject, getFileIndex } from '../utils/utils';
export const useOnProgress = () => {
    const { setValue } = useContext(UploadStateContext);
    return useCallback((event, file) => {
        setValue((prev) => {
            const fileIndex = getFileIndex(fileToObject(file, { status: 'uploading' }), prev);
            return prev.map((item, index) => {
                if (index !== fileIndex)
                    return item;
                return { ...item, percent: event.percent, status: 'uploading' };
            });
        });
    }, [setValue]);
};
